import { RowTypes } from './constants';

const getDefinedIds = (items = [], getId) => {
    const ids = items.map(getId).filter((id) => id !== undefined && id !== null && id !== '');

    return ids.length ? ids : undefined;
};

const buildVisibleRows = ({ ids, type }) => {
    return ids?.length ? { type, ids } : undefined;
};

export const buildCourseVisibleRows = (courses = []) =>
    buildVisibleRows({
        type: RowTypes.COURSES,
        ids: getDefinedIds(courses, (course) => course.course_id),
    });

export const buildAssignmentVisibleRows = (assignments = []) =>
    buildVisibleRows({
        type: RowTypes.ASSIGNMENTS,
        ids: getDefinedIds(assignments, (assignment) => assignment.id),
    });

export const buildSubmissionVisibleRows = ({ submissions = [], type = RowTypes.SUBMISSIONS }) =>
    buildVisibleRows({
        type,
        ids: getDefinedIds(submissions, (submission) => submission.id),
    });

export const buildPeopleVisibleRows = (accountUsers = []) =>
    buildVisibleRows({
        type: RowTypes.PEOPLE,
        ids: getDefinedIds(accountUsers, (user) => user.user_id || user.id || user.owner_account_id),
    });

export const buildRubricVisibleRows = (rubrics = []) =>
    buildVisibleRows({
        type: RowTypes.RUBRICS,
        ids: getDefinedIds(rubrics, (rubric) => rubric.id),
    });
